import axios from 'axios';

export async function loadCurrentProfile() {
  const token = localStorage.getItem('userToken');
  const network = localStorage.getItem('networkId');
  const response = await axios.get(process.env.REACT_APP_API_HOST + '/api/v2/profile', {
    headers: {Authorization: 'Bearer ' + token, 'App-Network': network || ''}
  });
  const profile = response?.data?.data;
  if (!profile || !Array.isArray(profile.roles)) throw new Error('Invalid profile permissions response');
  if (token !== localStorage.getItem('userToken') || network !== localStorage.getItem('networkId')) {
    throw new Error('Session changed while loading permissions');
  }
  localStorage.setItem('roles', JSON.stringify(profile.roles).toLowerCase());
  if (profile.employee?.id) localStorage.setItem('employeeId', profile.employee.id);
  return profile;
}
